import { getAuthedUser } from './getAuthedUser'

/**
 * This pulls the insurance product out of the member's policy if it exists.
 * Otherwise, it returns falsy so that we can use it in bool logic.
 *
 * @returns {string | undefined}
 */
export const getInsuranceProduct = () => {
  const { policy = {} } = getAuthedUser()
  const { insuranceProduct } = policy
  return insuranceProduct
}
